/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from "axios";
import { apiHandler, ApiRequestMethod } from "../config/api-handler";
import { ApiHeaders } from "@/common/hooks/headers.types";

/**
 * Generic API fetcher
 * @param url - Full endpoint URL
 * @param data - Request body or query params
 * @param headers - API headers
 * @param method - HTTP method (GET, POST, etc.)
 * @param encryption - whether request should be encrypted
 * @returns AxiosResponse wrapped in a Promise
 */

export const fetchApi = async <R, T>(
  url: string,
  data: any,
  headers: ApiHeaders,
  method: ApiRequestMethod = ApiRequestMethod.GET,
  encryption = false,
  options?: {
    deleteWithBody?: boolean;
  },
): Promise<AxiosResponse<T>> => {
  const isDeleteWithBody =
    method === ApiRequestMethod.DELETE && options?.deleteWithBody === true;

  // When sending FormData, remove Content-Type so axios sets multipart/form-data with boundary
  const finalHeaders =
    data instanceof FormData
      ? (({ "Content-Type": _, ...rest }) => rest)(headers)
      : headers;

  const apiRes = await apiHandler<R, T>({
    url,
    headers: finalHeaders,
    method,
    encryption,
    // Use 'params' for GET/DELETE, 'data' for POST/PUT/PATCH
    ...(method === ApiRequestMethod.GET ||
      (method === ApiRequestMethod.DELETE && !isDeleteWithBody)
      ? { params: data }
      : { requestBody: data }), // JSON body (OPT-IN)
  });
  return apiRes;
};
